import { render, staticRenderFns } from "./groupLeader.vue?vue&type=template&id=02c51335&scoped=true"
import script from "./groupLeader.vue?vue&type=script&lang=js"
export * from "./groupLeader.vue?vue&type=script&lang=js"
import style0 from "./groupLeader.vue?vue&type=style&index=0&id=02c51335&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c51335",
  null
  
)

export default component.exports